import React from 'react';

import parse from 'html-react-parser';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonSmallText from '../../../common-components/common-small-text';
import CommonTitle from '../../../common-components/common-title';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const taskPointList = [
    {
        img: '/images/svg/gge/gge-results__item-1.svg',
        title: 'Доработанный функционал',
        text: 'В&nbsp;результате мы&nbsp;доработали функционал 5&nbsp;сервисов: калькулятора, счетчика обращений, отписки от&nbsp;обновлений, скрытия и&nbsp;показа возможности подписаться.',
    },
    {
        img: '/images/svg/gge/gge-results__item-2.svg',
        title: 'Смена сервера',
        text: 'Провели масштабные работы по&nbsp;решению проблем с&nbsp;серверной частью и&nbsp;переносом проекта на&nbsp;другой сервер.',
    },
    {
        img: '/images/svg/gge/gge-results__item-3.svg',
        title: 'Поддержка',
        text: 'Продолжаем ежедневную работу над оперативным решением возникающих проблем, созданием новых блоков, страниц, форм и&nbsp;полей.',
    },
];

const Task = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper bigPaddings={true} caseName="gge-results">
                <div className="gge-results__wrapper">
                    <div className="gge-results__grid">
                        <div className="gge-results__info">
                            <CommonTitle className="gge-results__title">Результаты</CommonTitle>
                            <CommonSmallText>
                                <div className="gge-results__subtitle" href="#">
                                    По&nbsp;итогу проведенных работ мы&nbsp;выполнили все
                                    поставленные задачи и&nbsp;продолжаем поддерживать этот проект.
                                </div>
                            </CommonSmallText>
                        </div>
                        <div className="gge-results__points">
                            {taskPointList.map(({ img, title, text }, index) => (
                                <ScrollAnimation
                                    animateIn="fadeIn"
                                    offset={50}
                                    animateOnce={true}
                                    duration={1}
                                    className="gge-results__point-item"
                                    key={index}
                                >
                                    <div className="gge-results__point-title">
                                        <img
                                            className="gge-results__point-img"
                                            src={img}
                                            alt=""
                                            loading="lazy"
                                        />
                                        <CommonSmallTitle>{parse(title)}</CommonSmallTitle>
                                    </div>
                                    <CommonSmallText className="gge-results__point-text">
                                        {parse(text)}
                                    </CommonSmallText>
                                </ScrollAnimation>
                            ))}
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Task;
